/**
 * Resolución de paths para sprites de decoración de mapa.
 *
 * Las decoraciones se referencian por prefijo de key en las tiles del mapa:
 * - `tree<N>`        -> árboles nuevos en `/assets/world/trees/tree<N>.png`
 * - `decoration<N>`  -> decoraciones legacy en `/assets/decoration/decoration<N>.png`
 * - `entrance<N>`    -> entradas de dungeon en `/assets/world/dungeons/entrances/entrance<N>.png`
 * - `house<N>_<p>`   -> partes de casas en `/assets/world/houses/house<N>_<p>.png`
 * - `desert<N>`      -> decoraciones de desierto en `/assets/world/desert/decoration_<N>.png`
 * - `snow<N>`        -> decoraciones de nieve en `/assets/world/snow/decoration_<N>.png`
 *
 * Mantener este helper como única fuente de verdad evita duplicar la lógica de
 * paths/prefijos en los call-sites de carga (GameScene, MapBackgroundRenderer,
 * MapEditorScene, AuthUI).
 */

/** Devuelve true si la key corresponde a una decoración de mapa (árbol, legacy, entrada o entrada de dungeon). */
export function isDecorationKey(key: string): boolean {
  return (
    key.startsWith('tree') ||
    key.startsWith('decoration') ||
    key.startsWith('entrance') ||
    key.startsWith('dgent_') ||
    key.startsWith('house') ||
    key.startsWith('desert') ||
    key.startsWith('snow')
  );
}

/** Resuelve la URL del PNG para una key de decoración según su prefijo. */
export function getDecorationAssetUrl(key: string): string {
  if (key.startsWith('dgent_')) {
    // Entrada de dungeon: `dgent_<nombre>__<archivo>` →
    // /assets/world/dungeons/<nombre>/<archivo>.png (movido de world/floors/dungeons/).
    const rest = key.slice('dgent_'.length);
    const sep = rest.indexOf('__');
    if (sep !== -1) {
      const dungeon = rest.slice(0, sep);
      const file = rest.slice(sep + 2);
      return `/assets/world/dungeons/${dungeon}/${file}.png`;
    }
  }
  if (key.startsWith('tree')) {
    return `/assets/world/trees/${key}.png`;
  }
  if (key.startsWith('entrance')) {
    return `/assets/world/dungeons/entrances/${key}.png`;
  }
  if (key.startsWith('house')) {
    return `/assets/world/houses/${key}.png`;
  }
  if (key.startsWith('desert')) {
    // `desert<N>` → /assets/world/desert/decoration_<N>.png
    return `/assets/world/desert/decoration_${key.slice('desert'.length)}.png`;
  }
  if (key.startsWith('snow')) {
    // `snow<N>` → /assets/world/snow/decoration_<N>.png
    return `/assets/world/snow/decoration_${key.slice('snow'.length)}.png`;
  }
  return `/assets/decoration/${key}.png`;
}
